import { render, staticRenderFns } from "./SpecialBoxModal.vue?vue&type=template&id=65e971c6"
import script from "./SpecialBoxModal.vue?vue&type=script&lang=js"
export * from "./SpecialBoxModal.vue?vue&type=script&lang=js"
import style0 from "./SpecialBoxModal.vue?vue&type=style&index=0&id=65e971c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports